var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.863 12.982 16.106 3l1.848 1.743-8.398 9.19-3.01-.422-3.592 3.592L1 15.412l2.43-2.43h3.433z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m13.412 14.567 6.76-7.342 2.113 1.902-6.18 6.285h-3.432l-5.44 5.599-1.85-1.848 4.173-4.595h3.856z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m19.697 16.363 5.018-5.282 1.901 1.902-4.33 4.437-3.064-.318-7.5 7.976-2.166-1.85 6.55-6.865h3.591z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m25.877 18.317 3.222-3.222 1.9 1.743-2.482 2.324-3.01-.423-9.666 10.246-1.902-1.743 8.715-9.296 3.222.37z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLit);
export default __webpack_public_path__ + "static/media/LIT.4ae9f1cd73d763aef58ff7eac931dfaf.svg";
export { ForwardRef as ReactComponent };